import { Dictionary } from "sbtech-sports-data-api-contracts";

export const getBetSlipOdds = (displayOdds: Dictionary<string>) =>
    (displayOdds && displayOdds.american) ? displayOdds.american.replace("−", "-") : "0";